var v1="<div class=\"confirm-button-container\"> <button class=\"btn btn-lightning\" ng-click=\"vm.handleClick()\" ng-disabled=\"!vm.enabled\">{{vm.settings.buttonText}}</button> <p class=\"help-block\" ng-if=\"vm.settings.helpText\" ng-bind-html=\"vm.settings.helpText\"></p> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaConfirmButton/lbaConfirmButton.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaConfirmButton/lbaConfirmButton.html
// module id = 443
// module chunks = 0